import { Box, Text } from 'wix-style-react';
import * as React from 'react';
export var CustomerEmail = function (_a) {
    var email = _a.email;
    return (email && (React.createElement(Box, { paddingBottom: "4px" },
        React.createElement(Text, { size: "tiny", weight: "thin", secondary: true, dataHook: "customer-email" }, email))));
};
//# sourceMappingURL=CustomerEmail.js.map